// assets
import { 
  DashboardOutlined, 
  BarChartOutlined, 
  LineChartOutlined, 
  PieChartOutlined,
  TableOutlined,
  FileTextOutlined
} from '@ant-design/icons';

// icons
const icons = {
  DashboardOutlined,
  BarChartOutlined,
  LineChartOutlined,
  PieChartOutlined,
  TableOutlined,
  FileTextOutlined
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const analytics = {
  id: 'analytics',
  title: 'Analytics',
  titleKey: 'menu.groups.analytics',
  titleVariant: 'h6',
  titleSx: { fontSize: 15, fontWeight: 700 },
  type: 'group',
  children: [
    {
      id: 'results',
      title: 'Results',
      titleKey: 'menu.items.results',
      type: 'item',
      url: '/analytics/results',
      icon: icons.BarChartOutlined,
      breadcrumbs: false
    },
    /*{
      id: 'dashboards',
      title: 'Dashboards',
      titleKey: 'menu.items.dashboards',
      type: 'item',
      url: '/analytics/dashboards',
      icon: icons.PieChartOutlined,
      breadcrumbs: false
    }*/
  ]
};

export default analytics;

